<template>
  <div class="pagination-container">
    <div class="pagination-wrapper">
      <el-pagination
        :background="background"
        :current-page.sync="page"
        :page-size.sync="limit"
        :layout="layout"
        :page-sizes="pageSizes"
        :total="total"
        v-bind="$attrs"
        @size-change="sizeChange"
        @current-change="currentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default () {
        return [this.pageSize, 20, 30, 40, 50]
      }
    },
    layout: {
      type: String,
      default: 'sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    page: {
      get () {
        return this.currentPage
      },
      set (val) {
        this.$emit('update:currentPage', val)
      }
    },
    limit: {
      get () {
        return this.pageSize
      },
      set (val) {
        this.$emit('update:pageSize', val)
      }
    }
  },
  methods: {
    sizeChange (size) {
      this.$emit('sizeChange', size)
    },
    currentChange (page) {
      this.$emit('currentChange', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  margin-bottom: 24px;
  .pagination-wrapper{
    display: inline-block;
  }
  .enterbtn{
    display: inline-block;
    width: 60px;
  }
}
.pagination-container.hidden {
  display: none;
}
</style>
